import { onLockRegister, onPageLoad, onSelectRegister } from './event_listeners';

window.merchantos.registerSwitch = {
  eventListeners: {
    onPageLoad,
    onSelectRegister,
    onLockRegister,
  },
};
